import { Pipe, PipeTransform } from '@angular/core';
import { isEmpty, isNil } from 'lodash';
import { MapStoreMunicipality } from '../models/municipality/Municipality';
import { MeterData } from '@app/energiedaten/models/energiedaten.state';
import { MeterAddressFormatUtility } from '@app/zahlerstand/utilities/meter-address-format.utility';

@Pipe({
  name: 'getMeterAddress',
})
export class GetMeterAddressPipe implements PipeTransform {
  transform(value: MeterData, municipality?: MapStoreMunicipality): string {
    if (isNil(value) || isEmpty(value)) {
      return '';
    }

    return MeterAddressFormatUtility.getMeterAddress(value, municipality);
  }
}
